import { createGlobalStyle } from "styled-components";
import "./imports.css";

const GlobalStyle = createGlobalStyle`
    .w-0 {
        width: 0;
    }
    .w-20 {
        width: 20%;
    }
`;

export default GlobalStyle;
